interface Props {
  color?: string;
  className?: string;
}

export default function MenuStarSvg(props: Props) {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.4233 7.08817L13.3609 3.49797C12.9779 2.83136 12.0173 2.82817 11.63 3.49222L9.45364 7.22309C9.16538 7.71726 8.6793 8.06432 8.11831 8.17651L5.1446 8.77126C4.37441 8.92529 4.0743 9.86638 4.61312 10.4379L6.76395 12.719C7.22388 13.2068 7.4088 13.8926 7.25645 14.5455L6.28292 18.7178C6.0828 19.5755 7.0089 20.2543 7.76657 19.8053L11.4808 17.6043C12.1095 17.2318 12.8913 17.2318 13.52 17.6043L17.2342 19.8053C17.9919 20.2543 18.918 19.5755 18.7179 18.7178L17.7358 14.509C17.5882 13.8763 17.757 13.2114 18.1887 12.7258L20.3421 10.3031C20.8552 9.7259 20.5482 8.80965 19.7908 8.65819L16.7653 8.05308C16.1998 7.93998 15.7106 7.58825 15.4233 7.08817Z'
        stroke={props.color || '#737389'}
        strokeWidth='2'
        stroke-miterlimit='10'
      />
    </svg>
  );
}
